<template>
    <vue-fab autoHideDirection="down" fabItemAnimate="default" size="normal"  :mainBtnColor="'#f4364c'" icon="translate" :style="{ bottom: '80px', left: '20px'}">
        <template v-for="(item, index) in items">
            <fab-item :key="index" @clickItem="clickItem(item.mode)" :idx="index" :title="item.title">
                <img :src="require(`@/assets/banderas/${item.image}`)" style="width: 100%;border-radius: 50%" />
            </fab-item>
        </template>      
    </vue-fab>
</template>
<script>

export default {
    data() {
        return {
            items: [
                {
                    title: "Español",
                    image: "esp.png",
                    mode: "es"
                },
                {
                    title: "English",
                    image: "eng.png",
                    mode: "en"
                },
                {
                    title: "Catalá",
                    image: "ca.png",
                    mode: "ca"
                },
                {
                    title: "Galego",
                    image: "gl.png",
                    mode: "gl"
                },
            ]
        }
    },
    created() {
        this.locale = this.$i18n.locale;
    },
    methods:{
        clickItem(idioma) {
            this.$i18n.locale = idioma;
            this.locale = idioma;
        }
    }
}
</script>

<style scoped>
</style>